export enum CountriesActionType {
  Set = 'countries/SET_COUNTRIES',
}
